import { GET_SUPPORT_TICKETS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    tickets: Ticket[];
    error?: string;
}

export interface Ticket {
    id: string;
    name: string;
    created_at: string;
    last_activity_at: string;
    status: string;
    members: string[];
    url: string;
    attachments: Attachment[];
}

interface Attachment {
    id: string;
    bytes: number;
    date: string;
    edgeColor: any;
    idMember: string;
    isUpload: boolean;
    mimeType: string;
    name: string;
    previews: any[];
    url: string;
    pos: number;
    fileName: string;
}

export default (): Promise<Response> => {
    return fetchWithRefresh(GET_SUPPORT_TICKETS).then((res) => res.json());
};
